const _app_options = require('../pdfjs-dist/lib/web/app_options')
const _ui_utils = require('../pdfjs-dist/lib/web/ui_utils.js')
// const _app_options = require("./app_options.js");
let size = {
  width: undefined,
  height: undefined
}
const scratchCanvas = document.createElement('canvas')
let disableCreateObjectURL = false
const onPrint = async (divId, pdfApp) => {
  try {
    disableCreateObjectURL =
      pdfApp.PDFViewerApplication.pdfDocument.loadingParams
        .disableCreateObjectURL
    for (
      let index = 0;
      index < pdfApp.PDFViewerApplication.pagesCount;
      index++
    ) {
      const result = await renderPage(
        pdfApp.PDFViewerApplication.pdfDocument,
        index + 1
      )
      // console.log("result.width".replace);
      if (index == 0) {
        size = result.size
        layout(result.size)
      }
      await useRenderedPage(result, scratchCanvas)
    }

    const contents = document.getElementById('printContainer')
    const frame1 = document.createElement('iframe')

    frame1.name = 'frame1'
    // frame1.style.position = "absolute";
    // frame1.style.top = "-1000000px";
    document.body.appendChild(frame1)
    const frameDoc = frame1.contentWindow
      ? frame1.contentWindow
      : frame1.contentDocument.document
        ? frame1.contentDocument.document
        : frame1.contentDocument
    frameDoc.document.open()
    frameDoc.document.write(`
    <html>
    <head>
      <title>Documento a Imprimir</title>
      <style>
          @media print {
            @page {
              margin: 0;
            }

            body[data-pdfjsprinting] #printContainer {
              display: block;
            }
            #printContainer {
              height: 100%;
            }
            /* wrapper around (scaled) print canvas elements */
            #printContainer > div {
              position: relative;
              top: 0;
              left: 0;
              width: 1px;
              height: 1px;
              overflow: visible;
              page-break-after: always;
              page-break-inside: avoid;
            }
          }

      </style>
      `)
    frameDoc.document.write(
      `</head>
        <body style="height: 100% !important" data-pdfjsprinting='true' >
        <div id=printContainer>
      `
    )
    frameDoc.document.write(contents.innerHTML)
    frameDoc.document.write(`</div>
    <style>
    @supports ((size:A4) and (size:1pt 1pt)) {@page { size: ${size.width}pt ${size.height}pt;}}
     </style>
    </body></html>`)
    frameDoc.document.close()
    setTimeout(() => {
      window.frames.frame1.focus()
      window.frames.frame1.print()
      document.body.removeChild(frame1)
    }, 500)
  } catch (e) {
    console.log(e)
  } finally {
    destroy()
  }
}

export { onPrint }

function renderPage (pdfDocument, pageNumber) {
  const PRINT_RESOLUTION =
    _app_options.AppOptions.get('printResolution') || 150
  const PRINT_UNITS = PRINT_RESOLUTION / 72.0

  let width
  let height
  let size = {
    width: undefined,
    height: undefined
  }
  return pdfDocument
    .getPage(pageNumber)
    .then(function (pdfPage) {
      const viewPort = pdfPage.getViewport({
        scale: 1
      })
      size = {
        width: viewPort.width,
        height: viewPort.height
      }
      width = Math.floor(viewPort.width * _ui_utils.CSS_UNITS) + 'px'
      height = Math.floor(viewPort.height * _ui_utils.CSS_UNITS) + 'px'
      scratchCanvas.width = Math.floor(viewPort.width * PRINT_UNITS)
      scratchCanvas.height = Math.floor(viewPort.height * PRINT_UNITS)
      const ctx = scratchCanvas.getContext('2d')
      ctx.save()
      ctx.fillStyle = 'rgb(255, 255, 255)'
      ctx.fillRect(0, 0, scratchCanvas.width, scratchCanvas.height)
      ctx.restore()

      const renderContext = {
        canvasContext: ctx,
        transform: [PRINT_UNITS, 0, 0, PRINT_UNITS, 0, 0],
        viewport: pdfPage.getViewport({
          scale: 1,
          rotation: viewPort.rotation
        }),
        intent: 'print'
      }
      return pdfPage.render(renderContext).promise
    })
    .then(function () {
      return {
        width,
        height,
        size
      }
    })
}

function useRenderedPage (printItem, scratchCanvas) {
  const img = document.createElement('img')
  img.style.width = printItem.width
  img.style.height = printItem.height

  if ('toBlob' in scratchCanvas && !disableCreateObjectURL) {
    scratchCanvas.toBlob(function (blob) {
      img.src = URL.createObjectURL(blob)
    })
  } else {
    img.src = scratchCanvas.toDataURL()
  }
  const wrapper = document.createElement('div')
  wrapper.appendChild(img)
  document.getElementById('printContainer').appendChild(wrapper)
  return new Promise(function (resolve, reject) {
    img.onload = resolve
    img.onerror = reject
  })
}

function layout (pageSize) {
  const body = document.querySelector('body')
  body.setAttribute('data-pdfjsprinting', true)
  // const hasEqualPageSizes = this.pagesOverview.every(function (size) {
  //   return (
  //     size.width === this.pagesOverview[0].width &&
  //     size.height === this.pagesOverview[0].height
  //   );
  // }, this);

  // if (!hasEqualPageSizes) {
  //   console.warn(
  //     "Not all pages have the same size. The printed " +
  //       "result may be incorrect!"
  //   );
  // }

  const pageStyleSheet = document.createElement('style')
  // const pageSize = this.pagesOverview[0];

  pageStyleSheet.textContent =
    '@supports ((size:A4) and (size:1pt 1pt)) {' +
    '@page { size: ' +
    pageSize.width +
    'pt ' +
    pageSize.height +
    'pt;}' +
    '}'
  body.appendChild(pageStyleSheet)
}

function destroy () {
  document.getElementById('printContainer').innerHTML = ''
  const body = document.querySelector('body')
  body.removeAttribute('data-pdfjsprinting')
  body.querySelector('style').remove()
}
